/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import PremiumLockIcon from 'bundles/audit/components/PremiumLockIcon';
import { useAuditUpgradeFlowData } from 'bundles/audit/contexts/AuditUpgradeFlowDataContext';

type Props = {
  defaultIcon: JSX.Element | null;
  size: number;
  title?: string;
  shouldShowLockIconOverride?: boolean;
};

const GradedPremiumIcon = (props: Props) => {
  const { defaultIcon, size, title = '', shouldShowLockIconOverride = false } = props;
  const auditUpgradeFlowContextData = useAuditUpgradeFlowData();
  const isAuditFlow = auditUpgradeFlowContextData !== null;

  return !isAuditFlow || shouldShowLockIconOverride ? defaultIcon : <PremiumLockIcon size={size} title={title} />;
};
export default GradedPremiumIcon;
